import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import MessagePage from '../../views/MessagePage/';
const GLOBAL = require('../../Globals');

class SMSTemplate extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			singlemessage : '',
			smscount : '',
			isUnicode : 0,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
  
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onClick(e){
		
		document.getElementById("smstempform").reset();
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		this.state.smscount = $("#smscount").val();
		
			PostData('message/addsmstemp',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'SMS Template Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("smstempform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		// }
	
	}
	
	
  render() {

	$('#sinmsgarea').keyup(function(){
		
		var chars = this.value.length;
		if( $("#isUnicode").prop("checked") ){
			var messages = Math.ceil(chars / 70),
			remaining = messages * 70 - (chars % (messages * 70) || messages * 70);	
			$("#smscount").val(messages);
		}
		else{
			var messages = Math.ceil(chars / 160),
			 remaining = messages * 160 - (chars % (messages * 160) || messages * 160);
			 $("#smscount").val(messages);
		}

		$("#remaining").text(remaining+ ' characters remaining ');
		$("#messages").text(messages + ' message(s)');
		
	});
	
    return (
		<div>
		  <MessagePage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			  <form action="" method="post" role="form" id="smstempform" encType="multipart/form-data" onSubmit={this.onSubmit} >
				<input type="hidden" id="smscount" />
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>SMS Templates</strong>
						</CardHeader>
						<CardBody>
						  <Row>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Message</Label>
								  <Input type="textarea" name="singlemessage" id="sinmsgarea" onChange={this.onChange} rows="5" placeholder="Type Message Here"/>
								  <span id="remaining">160 characters remaining </span>
								  <span id="messages">1 message(s)</span>
								</FormGroup>
								<FormGroup check inline>
									<Label className="form-check-label" check htmlFor="inline-checkbox1">Unicode Message</Label>&nbsp;&nbsp;&nbsp;
									<Input className="form-check-input" type="checkbox" id="isUnicode" onChange={this.onChange} name="isUnicode" value="1"/>
								</FormGroup>
							</Col>
						  </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary" className="btn-right" ><i className="fa fa-dot-circle-o"></i> Send</Button>
						</CardFooter>
					</Card>
				  </Col>
				</Row>
			  </form>
			</div>
		</div>
	)
  }
}

export default SMSTemplate;


// WEBPACK FOOTER //
// ./src/message/SMSTemplate/SMSTemplate.js